<template>
	<nav class="pagination">
		<ul>
			<li v-for="p in pages" :key="p">
				<button :class="{active: page === p}" type="button" class="page-btn" @click="changePage(p)">{{ p }}</button>
			</li>
		</ul>
	</nav>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
	name: "CarsPagination",
	computed: {
		...mapGetters({
			page: 'carPage',
			pages: 'carPages'
		})
	},
	methods: {
		changePage(p){
			this.$store.commit('carPage', p)
			this.loadCars()
		},
		...mapActions([
				'loadCars'
		])
	}
}
</script>

<style scoped>
nav.pagination ul {
	display: flex;
	gap: 10px;
	justify-content: center;
	max-width: 100vw;
	flex-wrap: wrap;
	margin: 10px 0;
}

.pama-app nav.pagination ul li button {
	width: auto;
	min-width: 35px;
	cursor: pointer;
}
</style>
